// src/components/Toaster.jsx
"use client";
import React from "react";
import { ToastContainer } from "react-toastify";
import { useTheme } from "@mui/material/styles";
import "react-toastify/dist/ReactToastify.css";

export default function Toaster() {
  const theme = useTheme();
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme={theme.palette.mode}               // "light" or "dark" in sync with MUI
      limit={3}
      containerStyle={{ zIndex: 999999 }}      // stay above Backdrop/Dialogs
      toastStyle={{
        borderRadius: 12,
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.shadows[4],
      }}
      progressStyle={{ background: theme.palette.primary.main }}
    />
  );
}
